var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-submission-requests" },
    [
      !_vm.canProjectAccess
        ? _c("p", [
            _vm._v("\n    " + _vm._s(_vm.$t("noTabPermission")) + "\n  "),
          ])
        : [
            _c(
              "div",
              { staticClass: "project-submission-requests-add clearfix" },
              [
                _vm.showNewSubmission
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn--orange add-submission-btn",
                        on: {
                          click: function () {
                            return _vm.newSubmission()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("action.newSubmission")))]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("div", [
              _c(
                "ul",
                {
                  staticClass: "accordion",
                  attrs: {
                    id: "project-submission-requests-accordion",
                    "data-accordion": "",
                    "data-deep-link": "true",
                    "data-allow-all-closed": "true",
                    "data-multi-expand": "true",
                    "data-update-history": "true",
                    "data-deep-link-smudge": "500",
                  },
                },
                [
                  _vm._l(_vm.submissions, function (submission, index) {
                    return [
                      (_vm.isContractor && !_vm.isProjectRepresentative) ||
                      !_vm.isDraft(submission) ||
                      submission.actionHistory.length
                        ? _c(
                            "li",
                            {
                              key: index,
                              staticClass: "accordion-item",
                              class: {
                                "is-active": _vm.activeItemId === submission.id,
                              },
                              attrs: {
                                id: "project-sr-" + index,
                                "data-accordion-item": "",
                              },
                            },
                            [
                              _vm.showSrOption(index) ||
                              _vm.showContractorOption(index)
                                ? _c(
                                    "div",
                                    { staticClass: "sr-options" },
                                    [
                                      _c(
                                        "dotted-dropdown",
                                        {
                                          attrs: {
                                            id:
                                              "project-sr-dotted-dropdown-" +
                                              index,
                                          },
                                        },
                                        [
                                          _vm.showSrOption(index)
                                            ? _c(
                                                "li",
                                                [
                                                  _c(
                                                    "DialogSlot",
                                                    {
                                                      ref: "changeRequestRef",
                                                      refInFor: true,
                                                      attrs: {
                                                        id: "project-sr-request-change-modal",
                                                        modalBtnClass:
                                                          "btn--transparent",
                                                        modalBtn: _vm.$t(
                                                          "action.requestChange"
                                                        ),
                                                        afterOpenModal:
                                                          _vm.resetData,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          class: [
                                                            "slot-content",
                                                            "modal-pure-text",
                                                          ],
                                                          attrs: {
                                                            slot: "content",
                                                          },
                                                          slot: "content",
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "hint.reopenSubmission"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("HKLTextarea", {
                                                            model: {
                                                              value:
                                                                _vm.unacceptedComment,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.unacceptedComment =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "unacceptedComment",
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _vm.unacceptedCommentHint
                                                            ? _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "text_red",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "hint.requestChangeReasonEmpty"
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            slot: "buttons",
                                                          },
                                                          slot: "buttons",
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn--orange close-reveal-modal",
                                                              attrs: {
                                                                type: "button",
                                                              },
                                                              on: {
                                                                click:
                                                                  function () {
                                                                    return _vm.requestChangeApproved(
                                                                      "changeRequestRef"
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "action.yesContinue"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showContractorOption(index)
                                            ? _c(
                                                "li",
                                                [
                                                  _c(
                                                    "DialogSlot",
                                                    {
                                                      ref: "cancelDraftRef",
                                                      refInFor: true,
                                                      attrs: {
                                                        id: "project-sr-cancel-draft-modal",
                                                        modalBtnClass:
                                                          "btn--transparent",
                                                        modalBtn:
                                                          _vm.$t(
                                                            "action.cancel"
                                                          ),
                                                        showCloseBtn: false,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          class: [
                                                            "slot-content",
                                                            "modal-pure-text",
                                                          ],
                                                          attrs: {
                                                            slot: "content",
                                                          },
                                                          slot: "content",
                                                        },
                                                        [
                                                          _c("pre", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "hint.cancelSubmission"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            slot: "buttons",
                                                          },
                                                          slot: "buttons",
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn--darkblue close-reveal-modal",
                                                              attrs: {
                                                                type: "button",
                                                              },
                                                              on: {
                                                                click:
                                                                  function () {
                                                                    return _vm.closeModal(
                                                                      "cancelDraftRef"
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "action.goback"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn--orange close-reveal-modal",
                                                              attrs: {
                                                                type: "button",
                                                              },
                                                              on: {
                                                                click:
                                                                  function () {
                                                                    return _vm.cancelSubmission(
                                                                      submission,
                                                                      "cancelDraftRef"
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "action.yesContinue"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "a",
                                { key: index, staticClass: "accordion-title" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "title-index row",
                                      class: {
                                        "add-padding-left":
                                          _vm.showSrOption(index) ||
                                          _vm.showContractorOption(index),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "small-6 medium-6 large-6 sr-name",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "project.submission.name"
                                                )
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.submissionsCount - index
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.stampFinal(
                                                  _vm.submissions[index]
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.getSubmStatusLabel(submission)[0]
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "medium-5 column uppercase-bold doc-status",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "submission-status-rect",
                                                  class:
                                                    _vm.getSubmStatusLabel(
                                                      submission
                                                    )[1],
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.getSubmStatusLabel(
                                                          submission
                                                        )[0]
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "accordion-content",
                                  attrs: {
                                    id: "project-sr-accordion-" + index,
                                    "data-tab-content": "",
                                  },
                                },
                                [
                                  _vm.isContractor &&
                                  !_vm.isProjectRepresentative &&
                                  _vm.editMode(submission.status)
                                    ? _c("submission", {
                                        key:
                                          submission.id +
                                          "-" +
                                          _vm.submissionKey,
                                        attrs: {
                                          submission: submission,
                                          companyName: _vm.companyName,
                                          disableSubmit:
                                            _vm.shouldDisableSubmit(
                                              submission.id
                                            ),
                                          draftSubmissionCounts:
                                            _vm.draftSubmissionCounts,
                                          srIndex: index,
                                          isContractor: _vm.isContractor,
                                          isFirstSubmission:
                                            _vm.isFirstSubmission,
                                          isEdit: _vm.editMode(
                                            submission.status
                                          ),
                                        },
                                        on: {
                                          refreshPage: function () {
                                            return _vm.refreshPage()
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (
                                    _vm.isContractor &&
                                    !_vm.isProjectRepresentative
                                      ? !_vm.editMode(submission.status)
                                      : true
                                  )
                                    ? _c("submission-view", {
                                        attrs: {
                                          submission: submission,
                                          companyName: _vm.companyName,
                                          srIndex: index,
                                          isContractor: _vm.isContractor,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }